module.exports = __webpack_public_path__ + "img/Truppführer_WP.0869550a.svg";